export default Object.freeze({
  Free: 1,
  Trial: 2,
  Paid: 3,
  Custom: 4,
  Internal: 5,
});
